<template>
  <StaticPage :type="type" />
</template>

<script>
import StaticPage from '../components/StaticPage.vue'

export default {
  name: 'StaticView',
  components: { StaticPage },
  props: {
    type: { type: String, default: 'about' }
  }
}
</script>
